import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi } from '../../api/resilience';

export function IntegrityDashboardPage() {
  const [checks, setChecks] = useState<{ id: string; backup_id?: string; status: string; checksum_ok: boolean }[]>([]);
  useEffect(() => { void resilienceApi.listIntegrity().then(setChecks); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Integrity Dashboard</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      <ul className="mt-6 space-y-2">{checks.map((c) => (
        <li key={c.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{c.backup_id ?? c.id} · {c.status} · checksum {c.checksum_ok ? 'OK' : 'FAIL'}</li>
      ))}{checks.length === 0 && <p className="text-sm text-slate-500">Run a backup to generate integrity checks.</p>}</ul>
    </div>
  );
}
